export const MENU_ITEM_SELECTED = 'MENU_ITEM_SELECTED'
export const BREADCRUMBS_CHANGE = 'BREADCRUMBS_CHANGE'
export const BREADCRUMBS_ACTION_CHANGE = 'BREADCRUMBS_ACTION_CHANGE'
export const MENU_TOGGLE_SHOW = 'MENU_TOGGLE_SHOW'
export const HIDE_MENU = 'HIDE_MENU'
